import React, { FC, useState, useEffect } from "react";
import { Button, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { ILplAuditDetail, lplService } from "../lplService";
import { getRandomStr } from "@/utils/utils";
import moment from "moment";


export const AuditDetail: FC<RouterParamType> = () => {
    const { selectedNavId, replaceNav, getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    const [dataSource, setDataSource] = useState<ILplAuditDetail[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (detailsInfo.id) {
            loadData()
        }
    }, [detailsInfo])


    const loadData = async () => {
        setLoading(true);
        const searchParams = {
            saleCode: detailsInfo.id,
            page: {
                pageSize: 1000,
                pageNum: 1,
            }
        };
        let { retData } = await lplService.auditPage(searchParams);
        const { records, ...pg } = retData;
        setDataSource((records ?? []).map(item => ({ ...item, key: getRandomStr() })));
        setLoading(false);
    }


    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '审批单号',
            width: 120,
            dataIndex: 'code',
        }, {
            title: '审批项目',
            width: 160,
            dataIndex: 'auditProject',
        }, {
            title: '审核人',
            width: 160,
            dataIndex: 'submitUser',
        }, {
            title: '审核日期',
            width: 160,
            dataIndex: 'createTime',
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '审核结果',
            width: 160,
            dataIndex: 'status',
            render: (t: string) => t == '0' ? "同意" : "驳回"
        }, {
            title: '审批人',
            width: 160,
            dataIndex: 'auditUser',
        }, {
            title: '审批日期',
            width: 160,
            dataIndex: 'updateTime',
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '审批结果',
            width: 160,
            dataIndex: 'note',
        }
    ];

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                replaceNav(selectedNavId, "6-1");
            }}
        >返回</Button>
    </>



    return (
        <YhBox title={action} style={{ marginBottom: "75px" }} >
            <Table
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}